var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.325 10.0001L12.5 6.17508V8.22508L11.7833 8.33341C8.19167 8.84175 5.75833 10.7251 4.36667 13.6084C6.3 12.2417 8.7 11.5834 11.6667 11.5834H12.5V13.8251M10.8333 12.4334C7.10833 12.6084 4.44167 13.9501 2.5 16.6667C3.33333 12.5001 5.83333 8.33341 11.6667 7.50008V4.16675L17.5 10.0001L11.6667 15.8334V12.4167C11.3917 12.4167 11.1167 12.4251 10.8333 12.4334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5a26500c5ee79308f531352e6fff1d85.svg";
export { ForwardRef as ReactComponent };